import { useState, useEffect } from 'react';
import HeroImage from '../assets/rizwanport.png';
import CV from '../assets/Rizwan CV.pdf';
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin } from "react-icons/fa";
import LightBulb from '../assets/lightbulb.png';

const Hero = () => {
  const [nameIndex, setNameIndex] = useState(0);
  const [direction, setDirection] = useState('forward');
  const [isPaused, setIsPaused] = useState(false);
  const fullName = "Rizwan Abdullah";

  useEffect(() => {
    const timer = setInterval(() => {
      if (isPaused) return;

      if (direction === 'forward') {
        if (nameIndex < fullName.length) {
          setNameIndex(prev => prev + 1);
        } else {
          setIsPaused(true);
          setTimeout(() => {
            setIsPaused(false);
            setDirection('backward');
          }, 3000); 
        }
      } else {
        if (nameIndex > 0) {
          setNameIndex(prev => prev - 1);
        } else {
          setDirection('forward');
        }
      }
    }, 100);

    return () => clearInterval(timer);
  }, [nameIndex, direction, isPaused]);

  const renderName = () => {
    return fullName.split('').map((char, index) => (
      <span
        key={index}
        className={`inline-block transition-opacity duration-200 ${
          index < nameIndex ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ transitionDelay: `${index * 50}ms` }}
      >
        {char === ' ' ? '\u00A0' : char}
      </span>
    ));
  };

  return (
    <div className='bg-black text-white min-h-screen w-full px-4 sm:px-6 lg:px-8 py-20 relative' id="home">
      <div className='max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center'>
        {/* Left Content Section */}
        <div className='order-2 md:order-1 space-y-6 text-center md:text-left'>
          <h1 className='text-3xl sm:text-4xl lg:text-6xl font-bold font-garamond leading-tight'>
            I&apos;m{" "}
            <span className='bg-clip-text text-transparent bg-gradient-to-r from-purple-800 to-purple-400 inline-block'>
              {renderName()}
            </span>
          </h1>
          
          <h2 className='font-montserrat text-xl sm:text-2xl lg:text-4xl font-semibold'>
            Web Developer
          </h2>
          
          <p className='text-sm sm:text-base lg:text-lg text-justify text-gray-300 max-w-2xl font-garamond leading-relaxed'>
            Welcome to my portfolio! I&apos;m Rizwan, a Computer Science graduate specializing in FullStack Web Development. I have worked on numerous projects, continuously refining my web development skills. This portfolio highlights my work, Experience, skills, and achievements, demonstrating how I can add value to your next project or opportunity.
          </p>
          <div className='flex justify-center md:justify-start gap-4'>
            {[
              { href: "https://www.linkedin.com/in/rizwan-abdullah-804208232/", icon: FaLinkedin, bg: "bg-blue-800" },
              { href: "https://github.com/rizwanabdullah11/", icon: FaGithub, bg: "bg-[#181717]" },
              { href: "https://www.instagram.com/rizwan_abdullah11/", icon: FaInstagram, bg: "bg-gradient-to-r from-[#833ab4] via-[#fd1d1d] to-[#fcb045]" },
              { href: "https://www.facebook.com/rizwan.abdullah.5458/", icon: FaFacebook, bg: "bg-blue-800" }
            ].map((social, index) => (
              <a 
                key={index}
                href={social.href}
                className={`${social.bg} p-3 rounded-full hover:scale-110 transition duration-300 ease-in-out`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <social.icon className="text-white text-xl" />
              </a>
            ))}
          </div>

          <div className='pt-4'>
            <a 
              href={CV} 
              target="_blank" 
              rel="noopener noreferrer"
              className='inline-block bg-gradient-to-r from-purple-800 to-purple-400 text-white px-8 py-3 rounded-full font-semibold hover:scale-105 transition duration-300 ease-in-out shadow-lg'
            >
              Download CV
            </a>
          </div>
        </div>

        <div className='order-1 md:order-2 relative'>
          <div className='relative inline-block'>
            <img 
              src={HeroImage} 
              alt="Rizwan Abdullah" 
              className='w-[280px] h-[280px] sm:w-[400px] sm:h-[400px] lg:w-[500px] lg:h-[500px] object-cover rounded-2xl shadow-2xl transition-transform duration-300 hover:scale-105'
            />
            <img 
              src={LightBulb} 
              alt="Light Bulb" 
              className='absolute -top-8 -right-4 w-12 sm:w-16 lg:w-20 animate-bounce'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;